let forms = {
   add_fuel_station: {
      icon: 'fa fa-gas-pump',
      title: 'Add Fuel Station',
      subtitle: 'Provide fuel station details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'name',
            validation: 'required|min:3|max:150', label: 'Station Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'company',
            validation: 'required|min:3|max:100', label: 'Company',
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'county', filterable: true, clearable: true,
            multiple: false, max_tag_count: 1, options: [], validation: 'required', label: 'County'
         },
      ]
   },
   upload_fuel_station: {
      icon: 'fa fa-upload',
      title: 'Upload Fuel Station',
      subtitle: 'Provide file containing fuel stations',
      forms: [
         {
            type: 'upload', class: 'col-12 big-upload', model: 'stations', validation: 'required', label: 'Fuel Stations',
            accept: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel', multiple: false
         },
      ]
   },
}

let tables = {
   stations: {
      icon: 'fa fa-gas-pump',
      title: 'Fuel Stations',
      table_fields: [
         { name: 'Name', align: 'l' },
         { name: 'Company', align: 'l' },
         { name: 'Region', align: 'l' },
         { name: 'Created At', align: 'c' },
         // { name: 'Actions', align: 'c' }
      ],
      search_fields: ["name","company","county"],
      row_data: [
         { type: 'text', field: 'name', class: 'bold' },
         { type: 'text', field: 'company', class: 'bold' },
         { type: 'text', field: 'county', class: 'bold' },
         { type: 'date', field: 'created_at', class: 'center bolder small', format: 'DD-MM-YYYY HH:mm' },
         // {
         //    type: 'action', field: 'name', class: 'center', icon: '', actions: [
         //       // {type: 'title', title: 'Actions'},
         //       { type: 'menu', title: 'View', event: 'station:view' },
         //       { type: 'menu', title: 'Edit', event: 'station:edit', icon: 'fa-edit' },
         //       { type: 'menu', title: 'Delete', event: 'station:delete', icon: 'fa-trash-alt' },
         //    ]
         // },
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}